<div [formGroup]="parts">
    <input  formControlName="textDate" [textMask]="{mask: datemask}" (change)="changeDate()" >
</div>


<!-- placeHolder="{{placeHolder}}" -->
